import { ApiService } from 'src/app/services/api.service';
import { FacilityUploadService } from 'src/app/services/facility-upload.service';
import { Injectable } from '@angular/core';
import { APIs } from '../config/api.constant';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class facilityService {
  detail: any;
  constructor(
    private apiService: ApiService,
    private facilityUploadService: FacilityUploadService
  ) {}

  getFacilityTypeList(ParkId) {
    return this.apiService.get(APIs.getFacilityTypeList, ParkId).pipe(
      map((res) => {

        return res.list;
      })
    );
  }
  getFaclitiesListByType(data) {
    return this.apiService.post(APIs.getFaclitiesListByType, data).pipe(
      map((res) => {

        return res.list;
      })
    );
  }
  getFacilityDetails(data) {
    return this.apiService.get(APIs.getFacilityDetails, data).pipe(
      map((res) => {

        return res.data;
      })
    );
  }
  getCanCalunit() {
    return this.apiService.get(APIs.GetFacilityCancellationUnit).pipe(
      map((res) => {

        return res.list;
      })
    );
  }

  updateFaclitiesImage(data) {
    return this.apiService.post(APIs.setFacilityTypeImage, data).pipe(
      map((res) => {

        return res.list;
      })
    );
  }

  updateFaclity(data) {
    return this.apiService.post(APIs.UpdateFacilityDetail, data).pipe(
      map((res) => {

        return res;
      })
    );
  }

  /** Update facility with multipart FormData (images as files). Uses dedicated upload service so Content-Type is omitted. */
  updateFaclityFormData(formData: FormData): Observable<any> {
    return this.facilityUploadService.postFormData(APIs.UpdateFacilityDetail, formData).pipe(
      map((res) => res)
    );
  }
  AddFaclity(data) {
    return this.apiService.post(APIs.CreateFacility, data).pipe(
      map((res) => {

        return res;
      })
    );
  }

  /** Create facility with multipart FormData (images as files). Uses dedicated upload service so Content-Type is omitted. */
  AddFaclityFormData(formData: FormData): Observable<any> {
    return this.facilityUploadService.postFormData(APIs.CreateFacility, formData).pipe(
      map((res) => res)
    );
  }
  deleteFacility(data) {
    return this.apiService.get(APIs.deleteFacility, data).pipe(
      map((res) => {

        return res.list;
      })
    );
  }
  GetBookedFacilityList(data) {
    return this.apiService.post(APIs.GetBookedFacilityList, data).pipe(
      map((res) => {

        return res.list;
      })
    );
  }

  uploadImage(event) {
    return new Promise((resolve, reject) => {
      let url: string | ArrayBuffer;
      console.log('came here 1', event);
      if (event.target.files && event.target.files[0]) {
        console.log(event.target.files[0].size);
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event) => {
          console.log('event', event);
          url = event.target.result;
          resolve(url);
        };
      }
    });
  }

  getGSTDetail() {
    return this.apiService.get(APIs.getGSTDetail).pipe(
      map((res) => {
        return res?.list;
      })
    );
  }

  disburseDeposit(data) {
    return this.apiService.post(APIs.disburseDeposit, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  cancelBooking(data) {
    return this.apiService.put(APIs.cancelFacilityBooking, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  fetchFacilityBookingTypes() {
    return this.apiService.get(APIs.getFacilytyBookingType).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getFacilityTimeLine(data) {
    return this.apiService.post(APIs.getFacilytyTimeLineDetails, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  bookNewFacility(data) {
    return this.apiService.post(APIs.bookFacility, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getAllFacilityBlockData(data) {
    return this.apiService.post(APIs.getAllBlockDates, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  cancelBlockedFacility(data): Observable<any> {
    return this.apiService.post(APIs.cancelBlockedFacility, data).pipe(map(response => {
      return response;
    }));
  }

  getAllFacilityList(data) {
    return this.apiService.post(APIs.getFacilityList, data).pipe(
      map((res) => {
        return res.list;
      })
    );
  }
}
